import type { CreateClientConfig } from './generated/v1/client'

/**
 * Runtime config consumed by every Hey API generated `client.gen.ts` in this
 * package (wired via `runtimeConfigPath` in openapi-ts.config.ts).
 *
 * The `CreateClientConfig` type is identical across generated versions since
 * we use the same `@hey-api/client-fetch` plugin for each, so importing it
 * from the v1 generated bundle is fine and avoids depending on the
 * `@hey-api/client-fetch` package's separate type identity.
 */
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: '/api',
  credentials: 'include',
  headers: {
    ...(config?.headers ?? {}),
    Accept: 'application/json',
  },
})
